import { Col, Container, Row, Card, Table, Dropdown } from "react-bootstrap";
import { useState, useEffect } from "react";
import moment from "moment";
import ReactApexChart from 'react-apexcharts';
import { useNavigate } from "react-router";
import Header from "../../Component/Header";
import FullScreenLoader from "../../Component/Loader";
import "./style.css"
import walletIcon from "../../Asset/Img/wallet-icon.svg";
import downArrowIcon from "../../Asset/Img/download-arrow-icon.svg";
import SearchableDropdown from "../../Component/Dropdown";
import { getDepartments, getVendors, getDepartmentGraph, getShippingData, getPurchaseStatus, getPurchaseData, getPurchaseDepartmentData } from "../../Services/dashboard"

function Dashboard() {
  const [showLoader, setShowLoader] = useState(false);
  const [Department, setDepartmentOptions] = useState([]);
  const [purchaseStatus, setPurchaseStatus] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState({});
  const [status, setStatus] = useState('');
  const [vendorGraphData, setVendorGraphData] = useState({});
  const [shippingGraphData, setShippingGraphData] = useState({});
  const [departmentGraphData, setDepartmentGraphData] = useState({});
  const [purchasedepartmentData, setPurchasedepartmentData] = useState({});
  const [purchanseVendorData, setPurchanseVendorData] = useState({});
  const [start_date, setStart_date] = useState('');
  const [end_date, setEnd_date] = useState('');



  const [selectedApp, setSelectedApp] = useState({ label: 'Purchase Order', value: 'Purchase Order' });
  const [poList, setPoList] = useState(["S3S415321",
    "S3S415320",
    "S3S415319",
    "CS3S002637",
    "CS3S002636",
    "S3S415317",]);
  const [prList, setPrList] = useState(["PR00016430",
    "PR00016429",
    "PR00016428",
    "PR00016427",
    "PR00016319",
    "PR00016426",]);
  const [selectedPO, setSelectedPO] = useState('');
  const [selectedPR, setSelectedPR] = useState('');


  const [vendorSeriesData, setVendorSeriesData] = useState({
    series: [],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
          show: false
        },
      },
      labels: [],
      colors: [
        'rgba(9, 47, 87, 1)',
        'rgba(118, 188, 29, 1)'
      ],
      legend: {
        position: 'top',
        horizontalAlign: 'top',
        fontSize: '14px',
        markers: {
          width: 12,
          height: 12
        },
        itemMargin: {
          vertical: 5
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: 'end',
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: false
      },

    },
  });

  const [purchaseVendorSeries, setPurchaseVendorSeries] = useState({
    series: [],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
          show: false
        },
      },
      labels: [],
      colors: [
        'rgba(9, 47, 87, 1)',
        'rgba(118, 188, 29, 1)'
      ],
      legend: {
        position: 'top',
        horizontalAlign: 'top',
        fontSize: '14px',
        markers: {
          width: 12,
          height: 12
        },
        itemMargin: {
          vertical: 5
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: 'end',
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: false
      },

    },
  });

  const [departmentSeries, setDepartmentSeries] = useState(
    {
      series: departmentGraphData?.series ? departmentGraphData?.series : [],
      options: {
        chart: {
          type: 'donut',
        },
        labels: departmentGraphData?.labels ? departmentGraphData?.labels : [],
        colors: [
          'rgba(9, 47, 87, 1)',
          'rgba(126, 157, 184, 1)',
          'rgba(118, 188, 29, 1)',
          'rgba(186, 221, 142, 1)'
        ],
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          fontSize: '14px',
          markers: {
            width: 12,
            height: 12
          },
          itemMargin: {
            vertical: 5
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '60%'  //
            }
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: "100%"
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      }
    }
  )

  const [purchaseDepartmentSeries, setPurchaseDepartmentSeries] = useState(
    {
      series: purchasedepartmentData?.series ? purchasedepartmentData?.series : [],
      options: {
        chart: {
          type: 'donut',
        },
        labels: purchasedepartmentData?.labels ? purchasedepartmentData?.labels : [],
        colors: [
          'rgba(9, 47, 87, 1)',
          'rgba(126, 157, 184, 1)',
          'rgba(118, 188, 29, 1)',
          'rgba(186, 221, 142, 1)'
        ],
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          fontSize: '14px',
          markers: {
            width: 12,
            height: 12
          },
          itemMargin: {
            vertical: 5
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '60%'  //
            }
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: "100%"
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      }
    }
  )

  const [mailSeries, setMailSeries] = useState(
    {
      series: [],
      options: {
        chart: {
          type: 'donut',
        },
        labels: [],
        colors: [
          'rgba(9, 47, 87, 1)',
          'rgba(126, 157, 184, 1)',
          'rgba(118, 188, 29, 1)',
        ],
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          fontSize: '14px',
          markers: {
            width: 12,
            height: 12
          },
          itemMargin: {
            vertical: 5
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '60%'  //
            }
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: "100%"
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      }
    }
  )

  const [templateSeries, setTemplateSeries] = useState({
    series: [
      {
        name: 'Total',
        data: [71, 60, 200, 47, 103, 51, 68, 95]
      },
      {
        name: 'Request Submitted',
        data: [61, 10, 100, 17, 70, 11, 68, 15]
      },
      {
        name: 'Completed',
        data: [10, 40, 100, 30, 33, 51, 40, 80]
      }
    ],
    options: {
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false
        },
      },
      xaxis: {
        categories: [
          "ADD", "Delivery", "DEPLOY", "RASHIP", "RELEASE", "RESUPPLY", "RETURN", "SWAP"
        ],
        title: {
          text: 'Request Type'
        }
      },
      colors: [
        'rgba(9, 47, 87, 1)',
        'rgba(118, 188, 29, 1)',
      ],
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        fontSize: '14px',
        markers: {
          width: 12,
          height: 12
        },
        itemMargin: {
          vertical: 5
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
          columnWidth: '60%',
          dataLabels: {
            total: {
              enabled: true,
              style: {
                fontSize: '14px',
                fontWeight: 'bold',
                colors: ['#000']
              }
            }
          }
        }
      },
      dataLabels: {
        enabled: false // disable per-bar labels, we only want total at top
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 300
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    }
  });


  useEffect(() => {
    const fetchData = async () => {
      fetchDepartmentList();
      fetchDepartmentGraph();
      fetchShippingGraph()
      fetchPurchaseStatus()
      fetchPurchaseDepartment()
    };

    fetchData();
  }, [status, selectedPO, selectedPR, selectedDepartment, start_date, end_date]);



  useEffect(() => {
    if (!departmentGraphData.series) return
    setDepartmentSeries({
      ...departmentSeries,
      series: departmentGraphData.series,
      options: {
        ...departmentSeries.options,
        labels: departmentGraphData.labels
      }
    });

  }, [departmentGraphData]);

  useEffect(() => {
    if (!shippingGraphData.SummaryDetails) return
    setMailSeries({
      ...mailSeries,
      series: shippingGraphData?.SummaryDetails && shippingGraphData?.SummaryDetails?.data ? shippingGraphData?.SummaryDetails?.data : [],
      options: {
        ...mailSeries.options,
        labels: shippingGraphData?.SummaryDetails && shippingGraphData?.SummaryDetails?.labels ? shippingGraphData?.SummaryDetails?.labels : []
      }
    });
    setTemplateSeries({
      ...templateSeries,
      series: shippingGraphData?.RequestDetails && shippingGraphData?.RequestDetails?.data ? shippingGraphData?.RequestDetails?.data : [],
      options: {
        ...templateSeries.options,
        labels: shippingGraphData?.RequestDetails && shippingGraphData?.RequestDetails?.labels ? shippingGraphData?.RequestDetails?.labels : []
      }
    });

  }, [shippingGraphData]);


  useEffect(() => {
    if (!vendorGraphData.series) return
    setVendorSeriesData({
      ...vendorSeriesData,
      series: vendorGraphData?.series,
      options:
      {
        ...vendorSeriesData.options,
        labels: vendorGraphData.labels
      }

    })
  }, [vendorGraphData]);

  useEffect(() => {
    if (!purchanseVendorData.series) return
    setPurchaseVendorSeries({
      ...purchaseVendorSeries,
      series: vendorGraphData?.series,
      options:
      {
        ...purchaseVendorSeries.options,
        labels: vendorGraphData.labels
      }

    })
  }, [purchanseVendorData]);


  useEffect(() => {
    if (!purchasedepartmentData.series) return
    setPurchaseDepartmentSeries({
      ...purchaseDepartmentSeries,
      series: purchasedepartmentData?.series,
      options:
      {
        ...purchaseDepartmentSeries.options,
        labels: purchasedepartmentData.labels
      }

    })
  }, [purchasedepartmentData]);


  let fetchPurchaseStatus = async () => {
    //let data = await getPurchaseStatus(localStorage?.access_token)

  }

  let fetchDepartmentList = async () => {
    setShowLoader(true)
    let data = await getDepartments(localStorage?.access_token)
    if (data?.data?.status_code == 200) {
      const output = data?.data?.departments?.map(item => ({
        label: item,
        value: item
      }));
      setDepartmentOptions(output)
    }
  }

  let fetchDepartmentGraph = async () => {
    setShowLoader(true)
    let payload = {
      status: status,
      department: selectedDepartment && selectedDepartment.value ? selectedDepartment.value : ''
    }
    let data = await getDepartmentGraph(payload, localStorage?.access_token)
    fetchVendorsGraph();
    if (data?.data?.status_code == 200) {
      setDepartmentGraphData(data?.data?.data)
    }
  }


  let fetchPurchaseDepartment = async () => {
    let payload = {
      status: status,
      department: selectedDepartment && selectedDepartment.value ? selectedDepartment.value : ''
    }
    let data = await getPurchaseDepartmentData(payload, localStorage?.access_token)
    fetchPurchaseVendor();
    if (data?.data?.status_code == 200) {
      setPurchasedepartmentData(data?.data?.data)
    }
  }


  let fetchPurchaseVendor = async () => {
    let payload = {
      status: status,
      department: selectedDepartment && selectedDepartment.value ? selectedDepartment.value : ''
    }
    let data = await getPurchaseData(payload, localStorage?.access_token)
    console.log("vendor data ", data)
    setPurchanseVendorData(data?.data?.data)
  }

  let fetchShippingGraph = async () => {
    let payload = '';
    if (start_date && end_date) {
      payload = `?start_date=${start_date}&end_date=${end_date}`;
    } else if (start_date) {
      payload = `?start_date=${start_date}`;
    } else if (end_date) {
      payload = `?end_date=${end_date}`;
    }

    console.log("payload--------------------", payload); 
    let data = await getShippingData(localStorage?.access_token,payload)
    if (data && data?.data?.status_code === 200) {
      setShippingGraphData(data?.data?.data)

    }
  }


  let fetchVendorsGraph = async () => {
    let payload = {
      status: status,
      po: selectedPO,
      pr: selectedPR
    }
    let data = await getVendors(payload, localStorage?.access_token)
    setShowLoader(false)
    if (data?.data?.status_code == 200) {
      setVendorGraphData(data.data.data)
    }
  }

  let handleFilterSelect = (value, filter) => {
    if (filter == 'department') {
      setSelectedDepartment(value)
    }
    else if (filter == 'app') {
      setSelectedApp(value)
    }
  }

  let handleStatusChange = (e, type) => {
    if (type == status) {
      setStatus('')
    } else {
      setStatus(type)
    }
  }
  let handleDateChange = (e, type) => {
    if (type == 'start') {
      setStart_date(e.target.value)
    } else {
      setEnd_date(e.target.value)
    }
  }

  return (
    <div className="wrapper">
      {showLoader ? <FullScreenLoader></FullScreenLoader> : null}
      <Header />
      <div class="container-layout">
        <div className="header-top-wgt pb-3">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="heading-main">
                  <h2 className="title-main-txt">Dashboard</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={4} xl={3}>
                <div className="field-date-card mb-0">
                  <label className="label-txt-wt">Select App</label>
                  <div className="select-dropdown-stage position-relative">
                    <div className="select-option-multi">
                      <SearchableDropdown
                        showAll={true}
                        options={[
                          { label: 'Purchase Order', value: 'Purchase Order' },
                          { label: 'Shipping Management', value: 'Shipping Management' },
                          { label: 'Order Management', value: 'Order Management' },
                        ]}
                        onSelect={(e) =>
                          handleFilterSelect(
                            e,
                            'app'

                          )
                        }
                        placeholder="Select..."
                        defaultSelected={selectedApp ? selectedApp.label : ''}

                      />
                    </div>
                    <span className="icon-field-wt"><img src={downArrowIcon} alt="icon" /></span>
                  </div>
                </div>
              </Col>
              {
                selectedApp && selectedApp?.label === 'Order Management' || selectedApp && selectedApp?.label === 'Purchase Order' ?
                  <>
                    <Col xs={12} sm={6} md={8} xl={9}>
                      <Row className="">
                        <Col xs={12} md={12}>
                          <div className="d-md-flex gap-3 align-items-start">
                            {/* Department dropdown */}
                            <div className="field-date-card flex-department mb-3 flex-sm-fill">
                              <label className="label-txt-wt">Department</label>
                              <div className="select-dropdown-stage position-relative">
                                <div className="select-option-multi dropdown-equipment-old">
                                  <SearchableDropdown
                                    options={Department}
                                    onSelect={(e) => handleFilterSelect(e, 'department')}
                                    placeholder="Select..."
                                    defaultSelected={selectedDepartment ? selectedDepartment.label : ''}
                                  />
                                </div>
                                <span className="icon-field-wt">
                                  <img src={downArrowIcon} alt="icon" />
                                </span>
                              </div>
                            </div>

                            {/* Status checkboxes */}
                            <div className="form-group group-status-wp flex-fill">
                              <label className="label-txt-wt">Status</label>
                              <ul className="status-check-itm">
                                <li className="list-check-status">
                                  <label className="check-lbl-pt">
                                    <input
                                      onChange={(e) => handleStatusChange(e, 'Accepted')}
                                      type="checkbox"
                                      checked={status === 'Accepted'}
                                    />
                                    <span className="st-label d-inline-block ms-2">Accepted</span>
                                  </label>
                                </li>
                                <li className="list-check-status">
                                  <label className="check-lbl-pt">
                                    <input
                                      onChange={(e) => handleStatusChange(e, 'Cancelled')}
                                      type="checkbox"
                                      checked={status === 'Cancelled'}
                                    />
                                    <span className="st-label d-inline-block ms-2">Cancelled</span>
                                  </label>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </Col>

                        {/* <Col xs={6} md={6} lg={4}>
                          <div className="d-flex flex-wrap listed-row-wp">
                            <div className="list-wappro">
                              <div className="form-group-list mb-3">
                                <label class="label-txt-wt">PO#</label>
                                <div className="scroll-list-check">
                                  <ul className="status-check-itm">
                                    {
                                      poList.map((val, i) => {
                                        return (
                                          <li key={i} className="list-check-status"><label className="check-lbl-pt"><input onChange={(e) => handlePoChange(e, val)} type="checkbox" checked={selectedPO === val ? true : false} /><span className="st-label d-inline-block ms-2">{val}</span></label></li>

                                        )
                                      })
                                    }

                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="list-wappro">
                              <div className="form-group-list mb-3">
                                <label class="label-txt-wt">PR#</label>
                                <div className="scroll-list-check">
                                  <ul className="status-check-itm">
                                    {
                                      prList.map((val, i) => {
                                        return (
                                          <li key={i} className="list-check-status"><label className="check-lbl-pt"><input onChange={(e) => handlePrChange(e, val)} type="checkbox" checked={selectedPR === val ? true : false} /><span className="st-label d-inline-block ms-2">{val}</span></label></li>

                                        )
                                      })
                                    }
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col> */}
                        {/* <Col xs={12} md={6} lg={5}>
                    <div className="card-value-elemnt">
                      <div className="card-box-wgtwp">
                        <div className="d-flex">
                          <div className="icon-wlt"><img src={walletIcon} alt="" /></div>
                          <div className="side-cost-inform">
                            <h3 className="title-cst">Count of Status</h3>
                            <h4 className="price-head-bigtxt">1000</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col> */}
                      </Row>
                    </Col>
                  </>
                  :
                  null
              }

            </Row>
          </Container>
        </div>
        <div className="chart-dash-container">
          {
            selectedApp && selectedApp.label == 'Purchase Order' ?
              <>
                <Container fluid>
                  <Row className="less-space-row">
                    <Col xs={12} md={6} lg={6} xl={6} className="add-space-col">
                      <Card className="card-box-wap">
                        <Card.Title className="card-head-title border-0"><h3 className="title-card-wt">Sum of Total Vendor & Country</h3></Card.Title>
                        <Card.Body className="pt-0">
                          <div className="vendor_chart_ht">
                            {/* <img src={lineChart} alt="" /> */}
                            <ReactApexChart
                              options={vendorSeriesData.options}
                              series={vendorSeriesData.series} type="bar"
                              //height = {350}
                              height={Math.max(vendorSeriesData.series[0]?.data.length * 40, 400)} // dynamic height

                            />
                            <div className="bottom-txt-ttl text-center">
                              <span className="tottal-txt-chart">Sum of Total </span>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col xs={12} md={6} lg={6} xl={6} className="add-space-col">
                      <Card className="card-box-wap">
                        <Card.Title className="card-head-title"><h3 className="title-card-wt">Department</h3></Card.Title>
                        <Card.Body>
                          <div className="pt-3">
                            <ReactApexChart
                              key={departmentSeries.series.join(',')}
                              options={departmentSeries.options}
                              series={departmentSeries.series}
                              type="pie"
                              height={350}
                            />
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Container>
              </>
              :
              selectedApp && selectedApp.label === 'Shipping Management' ?
                <>
                  <Container fluid>
                    <Row>
                      <Col xs={12} md={4} lg={3}>
                        <div className="form-group mb-3 mb-md-4">
                          <label className="label-txt-fld">Start Date</label>
                          <div className="position-relative">
                            <input
                              value={start_date}
                              onChange={(e) => handleDateChange(e, 'start')}
                              type="date" placeholder="" className="form-control control-field-txt" />
                            <span className="icon-field-wt">
                              {/* <img src={calendarIcon} alt="icon" /> */}
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} md={4} lg={3}>
                        <div className="form-group mb-4">
                          <label className="label-txt-fld">End Date</label>
                          <div className="position-relative">
                            <input
                              value={end_date} onChange={(e) => handleDateChange(e, 'end')}
                              type="date" placeholder="" className="form-control control-field-txt" />
                            <span className="icon-field-wt">
                              {/* <img src={calendarIcon} alt="icon" /> */}
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="less-space-row">
                      <Col xs={12} md={6} lg={6} xl={6} className="add-space-col">
                        <Card className="card-box-wap">
                          <Card.Title className="card-head-title border-0">
                            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
                              <h3 className="title-card-wt">
                                Templates
                              </h3>
                              <p style={{ fontSize: '12px' }}>
                                {/* {`${moment(shippingGraphData?.StartDate).format('L')} - ${moment(shippingGraphData?.EndDate).format('L')}`} */}

                              </p>
                            </div>
                          </Card.Title>
                          <Card.Body className="pt-0">
                            <div className="">
                              {/* <img src={lineChart} alt="" /> */}
                              <ReactApexChart
                                key={templateSeries.series.join(',')}
                                options={templateSeries.options}
                                series={templateSeries.series}
                                type="bar"
                                height={350}
                              />
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>

                      <Col xs={12} md={6} lg={6} xl={6} className="add-space-col">
                        <Card className="card-box-wap">
                          <Card.Title className="card-head-title">
                            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
                              <h3 className="title-card-wt">
                                Mails
                              </h3>
                              <p style={{ fontSize: '12px' }}>
                                {/* {`${moment(shippingGraphData?.StartDate).format('L')} - ${moment(shippingGraphData?.EndDate).format('L')}`} */}

                              </p>
                            </div>
                          </Card.Title>
                          <Card.Body>
                            <div className="pt-3">
                              <ReactApexChart
                                key={mailSeries.series.join(',')}
                                options={mailSeries.options}
                                series={mailSeries.series}
                                type="pie"
                                height={350}
                                className="mails-chart"
                              />
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Container>
                </>
                :
                <>
                  <Container fluid>
                    <Row className="less-space-row">
                      <Col xs={12} md={6} lg={6} xl={6} className="add-space-col">
                        <Card className="card-box-wap">
                          <Card.Title className="card-head-title border-0"><h3 className="title-card-wt">Sum of Total Vendor & Country</h3></Card.Title>
                          <Card.Body className="pt-0">
                            <div className="vendor_chart_ht">
                              {/* <img src={lineChart} alt="" /> */}
                              <ReactApexChart
                                key={purchaseVendorSeries.series.join(',')}
                                options={purchaseVendorSeries.options}
                                series={purchaseVendorSeries.series}
                                type="bar"
                                height={purchaseVendorSeries.series ? Math.max(purchaseVendorSeries.series[0]?.data.length * 40, 400) : 350} // dynamic height
                              />
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>

                      <Col xs={12} md={6} lg={6} xl={6} className="add-space-col">
                        <Card className="card-box-wap">
                          <Card.Title className="card-head-title"><h3 className="title-card-wt">Department</h3></Card.Title>
                          <Card.Body>
                            <div className="pt-3">
                              <ReactApexChart
                                key={purchaseDepartmentSeries.series.join(',')}
                                options={purchaseDepartmentSeries.options}
                                series={purchaseDepartmentSeries.series}
                                type="pie"
                                height={350}
                              />
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Container>
                </>
          }

        </div>
        <div className="summary-contain">
          <Container fluid>
          </Container>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
